import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=146abc7c&scoped=true&"
import script from "./Announcement.vue?vue&type=script&lang=js&"
export * from "./Announcement.vue?vue&type=script&lang=js&"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=146abc7c&prod&lang=scss&scoped=true&"
import style1 from "./Announcement.vue?vue&type=style&index=1&id=146abc7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146abc7c",
  null
  
)

export default component.exports